export const APP_REFRESH_ID = 'app_refresh_id';
export const IDEMPOTENCE_KEY_HEADER_NAME = 'Idempotence-Key';
